import React from 'react'
import classnames from 'classnames'

import styles from './index.module.css'

const Tablet = () => {
  return (
    <section className={styles.tablet} >

      <div className={classnames(styles.first, styles.container)} >
        <div className={styles.blockText} >
          <h2>Best mobile TV experience&nbsp;...</h2>
          <p>
            iFeelSmart’s Mobile TV Applications have been designed to provide the best mobile and
  tablet experiences on both iOS and Android with an extensive range of features
          </p>
        </div>
      </div>

      <div className={classnames(styles.second, styles.container)}>
        <div className={styles.blockText}>
          <h2>...&nbsp;with advanced playback experience&nbsp;...</h2>
          <p>
            Using native player and DRM, iFeelSmart solution on both Android and IOS mobile devices provides advanced linear TV usages as start over, network DVR and network timeshifting. It also provides on demand playback experience for premium content available as transactional or subscription VOD.
          </p>
        </div>
      </div>

    </section>
  )
}

export default Tablet